import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-100/70 border-y border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-8">
        <div className="text-center mb-5">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            <a href="#category-nav">分类浏览</a>
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按分类发现你喜欢的<strong>韩漫大全</strong>作品</p>
        </div>
        <div className="grid grid-cols-4 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-3 md:p-4 rounded-lg bg-background-50 hover:bg-primary-50 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-foreground-700 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-xs md:text-sm text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap font-medium">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}